import { Toastr } from "@revvsales/components";

// Internals imports
import { TEMPLATE } from "../../../constants";

// Destructuring
const { APPROVAL_TYPE } = TEMPLATE;

const _showToastr = message => {
  Toastr.showToastr({
    type: "warning",
    message,
    timeout: 2000,
  });
};

export const _generateFollowersJson = (
  usersReverseHashMap,
  userGroupReverseHashMap,
  action,
) => {
  const payload = [];
  const approvalType = action.approvalType.value || action.approvalType;

  if (approvalType === "Sequential") {
    action.approvers.forEach((approver, index) => {
      // Generate User JSON
      if (approver.type === "user") {
        payload.push({
          type: "UNANIMOUS",
          order: index + 1,
          approvers: [
            {
              id: usersReverseHashMap[approver.value || approver.name],
            },
          ],
        });
      }
      // Generate Group JSON
      else {
        payload.push({
          type: "UNANIMOUS",
          order: index + 1,
          group_approvers: [
            {
              group_id:
                userGroupReverseHashMap[approver.value || approver.name],
            },
          ],
        });
      }
    });
  } else {
    const users = action.approvers.filter(approver => approver.type === "user");
    const groups = action.approvers.filter(
      approver => approver.type === "group",
    );

    payload.push({
      type: "UNANIMOUS",
      order: 1,
      approvers: users.map(user => {
        const obj = { id: usersReverseHashMap[user.value || user.name] };
        return obj;
      }),
      group_approvers: groups.map(user => {
        const obj = {
          group_id: userGroupReverseHashMap[user.value || user.name],
        };
        return obj;
      }),
    });
  }
  return payload;
};

// "_generateRuleScopes()" is used to return the "scopes" based on
// selection of "SUGGESTED TRIGGERS" types
// ex: "Pricebook Level" or "SKU Level" triggers
const _generateRuleScopes = condition => {
  const scopes = [];
  if (
    condition.type === "DEAL_SKU" &&
    (condition.priceBook.label === "All Price Books" ||
      condition.priceBook.name === "All Price Books")
  ) {
    scopes.push({
      object_type: "DEAL_SKU",
      object_id: condition.product.id,
    });
  } else if (condition.type === "DEAL_SKU") {
    scopes.push(
      {
        object_type: "DEAL_PRICEBOOK",
        object_id: condition.priceBook.id,
      },
      {
        object_type: "DEAL_SKU",
        object_id: condition.product.id,
      },
    );
  } else if (
    condition.priceBook.label === "All Price Books" ||
    condition.priceBook.name === "All Price Books"
  ) {
    // Leave the value as empty []
  } else {
    scopes.push({
      object_type: "DEAL_PRICEBOOK",
      object_id: condition.priceBook.id,
    });
  }
  return scopes;
};

export const validateWorkFlowFields = rules =>
  rules.every(data => {
    const { condition, action } = data;
    /*
    ==========================================
          Validate Condition View Data
    ==========================================
    */

    // Check if rule is selected

    if (condition.type === "" || condition.conditions.length === 0) {
      _showToastr("Kindly add a rule");
      return false;
    }

    // Check if pricebook field is filled
    if (!Object.keys(condition.priceBook).length > 0) {
      _showToastr("Kindly select a pricebook");
      return false;
    }

    // Check if product field is filled
    if (
      condition.type === "DEAL_SKU" &&
      !Object.keys(condition.product).length > 0
    ) {
      _showToastr("Kindly select a product");
      return false;
    }

    // CHECK IF ALL THE CONDITION FILEDS ARE FILLED
    let isAllConditionsFilled = true;
    condition.conditions.forEach(rows => {
      const isAllEmpty = Object.values(rows).every(value => value !== "");
      if (!isAllEmpty) {
        isAllConditionsFilled = false;
        return false;
      }
      return true;
    });
    if (!isAllConditionsFilled) {
      _showToastr("Kindly fill all condition fields");
      return false;
    }

    /*
    ==========================================
          Validate Action View Data
    ==========================================
    */

    if (!Object.keys(action.approvalType).length > 0) {
      _showToastr("Kindly select an approval type");
      return false;
    }

    if (
      action.approvers.length === 0 ||
      !Object.values(action.approvers[0]).length > 0
    ) {
      _showToastr("Kindly select atleast 1 approver");
      return false;
    }

    // CHECK IF ALL THE APPROVERS FILEDS ARE FILLED
    let isAllApproversFilled = true;
    action.approvers.forEach(rows => {
      const isAllEmpty = Object.values(rows).every(value => value !== "");
      if (!isAllEmpty) {
        isAllApproversFilled = false;
        return false;
      }
      return true;
    });

    if (!isAllApproversFilled) {
      _showToastr("Kindly fill all approver fields");
      return false;
    }

    if (action.triggerMessage === "") {
      _showToastr("Enter a trigger message, and then proceed.");
      return false;
    }

    if (action.emailSub === "") {
      _showToastr("Email Subject content can't be empty!");
      return false;
    }

    if (action.emailMsg === "") {
      _showToastr("Email content can't be empty!");
      return false;
    }

    if (action.replySub === "") {
      _showToastr("Email Subject content can't be empty!");
      return false;
    }

    if (action.replyMsg === "") {
      _showToastr("Email content can't be empty!");
      return false;
    }

    // Need ApprovalTypes for later

    // if (action.approvalType.value === "Quorum" && action.quorum === 0) {
    //   _showToastr("Kindly fill quorum field");
    //   return false;
    // }

    // if (
    //   action.approvalType.value === "Quorum" &&
    //   action.approvers.length < action.quorum
    // ) {
    //   _showToastr(`Kindly add atleas ${action.quorum + 1} approvers`);
    //   return false;
    // }

    return true;
  });

export const generatePayloadForWorkFlow = (formFields, metaData) => {
  const payload = [];
  const {
    attributesReverseHashMap,
    usersReverseHashMap,
    userGroupReverseHashMap,
  } = metaData;
  formFields.forEach(info => {
    const { condition, action, id } = info;

    // Temp logic to Change attribute values inside conditions
    condition.conditions.forEach(item => {
      item.param = attributesReverseHashMap[item.param];
    });

    const obj = {
      id,
      isDirty: info.isDirty || false,
      rule_scopes: _generateRuleScopes(condition),
      logical_op: condition.logicalOperator,
      conditions: condition.conditions,
      action: {
        type: "APPROVAL",
        data: {
          id: action.id,
          type: APPROVAL_TYPE[action.approvalType],
          levels: _generateFollowersJson(
            usersReverseHashMap,
            userGroupReverseHashMap,
            action,
          ),
          // followers: _mapNameToMailId(action.followers),
          request_subject: action.emailSub,
          request_email: action.emailMsg,
          reply_subject: action.replySub,
          reply_email: action.replyMsg,
          // follow_email: action.followersMsg,
        },
        trigger_message: action.triggerMessage,
      },
    };
    if (typeof info.id === "string") delete obj.id;
    payload.push(obj);
  });
  return payload;
};



// WEBPACK FOOTER //
// ./src/components/WorkFlow/ApprovalWrapper/methods.js